import * as Data$dMaybe from "../Data.Maybe/index.js";
import * as Data$dResult from "../Data.Result/index.js";
import * as Foreign$dEncoding from "../Foreign.Encoding/index.js";
import * as Foreign$dGeneric$dClass from "../Foreign.Generic.Class/index.js";
import * as Restaumatic$dValidation$dTypes from "../Restaumatic.Validation.Types/index.js";
const ClaimFODResponse = x => x;
const newtypeError = {Coercible0: () => {}};
const genericError = {to: x => x, from: x => x};
const decodeClaimFODResponse = {
  decode: /* #__PURE__ */ Foreign$dEncoding.defaultDecode(genericError)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor({reflectSymbol: () => "ClaimFODResponse"})({
    decodeArgs: /* #__PURE__ */ Foreign$dGeneric$dClass.decodeArgsArgument(/* #__PURE__ */ (() => {
      const decode2 = Data$dResult.decodeResult(Restaumatic$dValidation$dTypes.decodeValidationErrors1)(Foreign$dGeneric$dClass.booleanDecode).decode;
      return {decodeWithOptions: v => decode2};
    })()),
    decodeSingleRecordArg: Data$dMaybe.Nothing
  })(Foreign$dGeneric$dClass.genericCountArgsArgument))
};
export {ClaimFODResponse, decodeClaimFODResponse, genericError, newtypeError};
